import AsyncLock from "async-lock";
import { createSHA256 } from "hash-wasm";

const hasher = await createSHA256();

const computeSha256Internal = async (file: File, onProgress: (progress: number) => void): Promise<string> => {
    const chunkSize = 20 * 1024 * 1024;
    let offset = 0;
    hasher.init();
    const reader = new FileReader();
    while (offset < file.size) {
        console.log(`Reading chunk from ${offset} to ${offset + chunkSize}`);
        const chunk = file.slice(offset, offset + chunkSize);
        const buffer = await new Promise<ArrayBuffer>((resolve, reject) => {
            reader.onload = (e) => resolve(e.target?.result as ArrayBuffer);
            reader.onerror = () => reject(reader.error);
            reader.readAsArrayBuffer(chunk);
            console.log("Reading chunk...");
        });
        console.log(`Hashing chunk of size ${buffer.byteLength}`);
        hasher.update(new Uint8Array(buffer));
        console.log("Hashed chunk");
        offset += chunkSize;
        const progress = Math.min((offset / file.size) * 100, 100);
        onProgress(progress);
    }
    return hasher.digest("hex");
};

const lock = new AsyncLock();

export const computeSha256 = async (file: File, onProgress: (progress: number) => void): Promise<string> => {
    return await lock.acquire("computeSha256", async () => {
        return await computeSha256Internal(file, onProgress);
    });
};
